import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const anchorContextMenuClasses = generateClasses('AnchorContextMenu', [
  'root',
  'link',
  'flexContainer',
  'icon',
] as const);

const styles: Styles = ({ theme, theme: { palette, spacing } }) => {
  const {
    appHeader: { elementHoverBackgroundColor },
  } = getAppFrameTheme(theme);

  return {
    [`.${anchorContextMenuClasses.link}`]: {
      background: palette.grey[900],
      textDecoration: 'none',
      color: palette.grey[400],
      height: 40,
      padding: spacing(0, 2),
      display: 'flex',

      '&:hover': {
        background: elementHoverBackgroundColor,
      },
    },
    [`.${anchorContextMenuClasses.flexContainer}`]: {
      display: 'flex',
      alignItems: 'center',
    },
    [`.${anchorContextMenuClasses.icon}`]: {
      height: 24,
      width: 24,
      paddingRight: spacing(0.5),
    },
  };
};

export default styles;
